import type { FilterFieldStatementNode } from '../types/tree-nodes.js';

/** @internal */
export const statementStatusRegistry = new WeakMap<
  FilterFieldStatementNode,
  'complete' | 'incomplete' | 'indeterminate'
>();
